var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHd = function SvgHd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-210 -542)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 60",
    width: 44,
    height: 44,
    rx: 6,
    transform: "translate(210 542)",
    fill: "#e04a56"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1126",
    d: "M232 571.538a22.918 22.918 0 0 0-9.415 1.938A11.667 11.667 0 0 1 220 566a12 12 0 0 1 24 0 12.211 12.211 0 0 1-2.585 7.477 22.918 22.918 0 0 0-9.415-1.939Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 42",
    d: "M231.699 557.084v2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 43",
    d: "m238.547 559.456-1.261 1.261"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 44",
    d: "M241 566.301h-2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 45",
    d: "M222.412 566.301h2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 46",
    d: "m225.454 559.456 1.261 1.261"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 47",
    d: "m231.655 571.477-3-7"
  })))));
};
export default SvgHd;